// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn___t8GZ"};